import React, { useState } from "react";
import PropTypes from "prop-types";

import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import SettingsIcon from "@mui/icons-material/Settings";

import { CaseTableSettings } from "components/CasesTable/CaseTableSettings";

export function CaseTableSettingsButton(props) {
  const { columns, setColumns } = props;

  const [settingsCaseDialogVisible, setSettingsDialogVisible] = useState(false);

  const showSettingsDialog = () => setSettingsDialogVisible(true);

  return (
    <>
      <Tooltip
        title="Select which items display on your data table and reorder columns"
        aria-label="Case table settings button"
      >
        <Button
          variant="outlined"
          color="primary"
          data-qa="CM-Button-Settings"
          onClick={showSettingsDialog}
          startIcon={<SettingsIcon />}
          size="medium"
        >
          Configure
        </Button>
      </Tooltip>
      <CaseTableSettings
        open={settingsCaseDialogVisible}
        setCaseTableSettingsOpen={setSettingsDialogVisible}
        setColumns={setColumns}
        columns={columns}
      />
    </>
  );
}

CaseTableSettingsButton.propTypes = {
  setColumns: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired
};
